import { Injectable } from "@angular/core";

import { ApiGetService } from "../shared/core/apiget.service";

@Injectable()
export class SubmissionDetailService {
  constructor(private apiGetService: ApiGetService) {}
}
